import type { FC } from 'react';

import { Grid, Skeleton } from '@eneco/sparky';

import type { PagesByTags } from '../types';
import { Article } from './Article';

type Props = {
  articles: PagesByTags['articles'];
  isLoading: boolean;
  articlesPerPage: number;
};

const skeletonHeight = 330;

export const Articles: FC<Props> = ({ articles, isLoading, articlesPerPage }) => {
  return (
    <Grid columns={{ initial: 1, md: 2, lg: 3 }} gap={{ initial: 10, md: 16 }}>
      {isLoading
        ? Array.from({ length: articlesPerPage }, (_, i) => i + 1).map(num => (
            <Skeleton key={num} height={`${skeletonHeight}px`} />
          ))
        : articles.map(article => <Article key={article.url} {...article} />)}
    </Grid>
  );
};
